import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/checkout";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/checkout")(
  enRouteOptions(routeOptions, {
    svPath: "/checkout",
    title: 'Complete your purchase – Alkoholprovet',
    description: 'Secure checkout for premium access.',
    noindex: true,
  }),
);
